import { nsmiThemeConfig } from '../../../attachments-handler/src/lib/components/theme-manageer/nsmi-preset.config';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { createThemePreset, provideThemeCssVars } from '../../../attachments-handler/src/lib/components/theme-manageer/theme-factory';
import { taoThemeConfig } from '../../../attachments-handler/src/lib/components/theme-manageer/tao-preset.config';
import { ATTACHMENTS_HANDLER_CONFIG } from 'attachments-handler';
import { routes } from './app.routes';
import { errorInterceptor } from './interceptors/error.interceptor';
import { openerCheckInterceptor } from './interceptors/opener-check.interceptor';
import { environment } from '../environments/environment';
import { LogoutMessageListenerService } from './services/logout-message-listener.service';
import { provideSentryErrorHandler } from './monitoring/sentry';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideSentryErrorHandler(),
    provideAppInitializer(() => inject(LogoutMessageListenerService).init()),
    provideAnimationsAsync(),
    MessageService,
    { provide: ATTACHMENTS_HANDLER_CONFIG, useValue: { apiBaseUrl: environment.apiBaseUrl, apiUrl: environment.apiUrl, gridSystemEnabled: environment.gridSystemEnabled } },
    provideHttpClient(
      withInterceptors([openerCheckInterceptor, errorInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      })
    ),
    provideRouter(routes, withComponentInputBinding()),
    provideThemeCssVars(taoThemeConfig),
    providePrimeNG({
      theme: {
        preset: createThemePreset(taoThemeConfig),
        options: {
          darkModeSelector: false,
        },
      },
    }),
  ],
};
